module.exports = __webpack_public_path__ + "static/media/chats.5750cf52.svg";